import React, { Component } from 'react';
import { Modal, Steps, Button, message, Select, DatePicker, TimePicker } from 'antd';
import DriverModal from './DriverModal';
import TruckModal from './TruckModal';
import CarrierModal from './CarrierModal';
import axios from 'axios';
import Configuration from '../../Configuration';
import moment from 'moment';
const Step = Steps.Step;
const Option = Select.Option;

class VisitCarrierModal extends Component {
  constructor(props) {
    super(props);
    // Schemas for extarnal modals
    this.schemaDriver = {name: '', license: ''};
    this.schemaCarrier = {name: '', clave: ''};
    this.schemaTruck = {plates: '', reference: ''};
    // Validations
    this.headers = {Authorization: localStorage.getItem('visitapp:token')};
    this.steps = {step0: {visit_ticket_kind_id: false}, step1: {truck_kind_id: false, truck_id: false}, step2: {carrier_id: false, driver_id: false}, step3: {warehouse_id: false, weight_limit: true}, step4: {due_date: false, time: false}, step5: {details: true}};
    // Modal functions
    this.state = {step: 0, stepLimit: 5, stepValidation: this.steps, visitCarrier: {weight_limit: 30000}, carriers: [], drivers: [], visitTicketKinds: [], truckKinds: [], trucks: [], warehouses: [], modalDriverVisible: false, modalTruckVisible: false, modalCarrierVisible: false};
    this.handleNext = this.handleNext.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.showStep = this.showStep.bind(this);
    this.getCarriers = this.getCarriers.bind(this);
    this.getDrivers = this.getDrivers.bind(this);
    this.getVisitTicketKinds = this.getVisitTicketKinds.bind(this);
    this.getTruckKinds = this.getTruckKinds.bind(this);
    this.getTrucks = this.getTrucks.bind(this);
    this.getWarehouses = this.getWarehouses.bind(this);
    // Input values
    this.handleVisitTicketKind = this.handleVisitTicketKind.bind(this);
    this.handleCarrier = this.handleCarrier.bind(this);
    this.handleDriver = this.handleDriver.bind(this);
    this.handleTruckKind = this.handleTruckKind.bind(this);
    this.handleTruck = this.handleTruck.bind(this);
    this.handleWarehouse = this.handleWarehouse.bind(this);
    this.handleWeight = this.handleWeight.bind(this);
    this.handleDueDate = this.handleDueDate.bind(this);
    this.handleTime = this.handleTime.bind(this);
    this.handleDetails = this.handleDetails.bind(this);
    this.setProp = this.setProp.bind(this);
    // New driver
    this.handleOpenDriverModal = this.handleOpenDriverModal.bind(this);
    this.handleCloseDriverModal = this.handleCloseDriverModal.bind(this);
    this.handleDriverCreate = this.handleDriverCreate.bind(this);
    // New truck
    this.handleOpenTruckModal = this.handleOpenTruckModal.bind(this);
    this.handleCloseTruckModal = this.handleCloseTruckModal.bind(this);
    this.handleTruckCreate = this.handleTruckCreate.bind(this);
    // New carrier
    this.handleOpenCarrierModal = this.handleOpenCarrierModal.bind(this);
    this.handleCloseCarrierModal = this.handleCloseCarrierModal.bind(this);
    this.handleCarrierCreate = this.handleCarrierCreate.bind(this);
  }

  componentDidMount() {
    this.getCarriers();
    this.getDrivers();
    this.getVisitTicketKinds();
    this.getTruckKinds();
    this.getTrucks();
    this.getWarehouses();
  }

  handleNext() {
    if(!this.validateStep())
      return message.warning('Necesitas llenar los campos obligatorios')

    if(this.state.step === this.state.stepLimit) {
      this.props.handleSave(this.state.visitCarrier);
      this.setState({visitCarrier: {}, step: 0, stepValidation: this.steps});
    } else {
      let steps = 1;
      // Autocomplete date inputs
      if(this.state.step === 3 && this.props.hideDate) {
        this.handleDueDate(moment());
        this.handleTime(moment());
        steps = 2;
      }

      this.setState({step: this.state.step + steps});
    }
  }

  handleBack() {
    if(this.state.step === 0) {
      this.props.handleClose('carrierVisible');
    } else {
      this.setState({step: this.state.step - 1});
    }
  }

  validateStep() {
    let steps = 0;
    let total = 0;
    for(let item in this.state.stepValidation[`step${this.state.step}`]) {
      if(this.state.stepValidation[`step${this.state.step}`][item]) {
        steps += 1;
      }
      total += 1;
    }
    
    if(steps === total) {
      return true;
    } else {
      return false;
    }
  }

  getCarriers() {
    axios.get(`${Configuration.apiServer}/api/v1/carriers`, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.setState({carriers: resp.data});
    });
  }

  getVisitTicketKinds() {
    axios.get(`${Configuration.apiServer}/api/v1/visit_ticket_kinds`, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.setState({visitTicketKinds: resp.data});
    });
  }

  getDrivers() {
    axios.get(`${Configuration.apiServer}/api/v1/drivers`, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.setState({drivers: resp.data});
    });
  }

  getTruckKinds() {
    axios.get(`${Configuration.apiServer}/api/v1/truck_kinds`, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.setState({truckKinds: resp.data});
    });
  }

  getTrucks() {
    axios.get(`${Configuration.apiServer}/api/v1/trucks`, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.setState({trucks: resp.data});
    });
  }

  getWarehouses() {
    axios.get(`${Configuration.apiServer}/api/v1/warehouses`, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.setState({warehouses: resp.data});
    });
  }

  handleOpenDriverModal(kind, record) {
    this.setState({modalDriverVisible: true});
  }

  handleCloseDriverModal() {
    this.setState({modalDriverVisible: false});
  }

  handleOpenTruckModal(kind, record) {
    this.setState({modalTruckVisible: true});
  }

  handleCloseTruckModal() {
    this.setState({modalTruckVisible: false});
  }

  handleOpenCarrierModal(kind, record) {
    this.setState({modalCarrierVisible: true});
  }

  handleCloseCarrierModal() {
    this.setState({modalCarrierVisible: false});
  }

  handleDriverCreate(record) {
    axios.post(`${Configuration.apiServer}/api/v1/drivers`, {driver: record}, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.getDrivers();
      this.setState({modalDriverVisible: false});
      message.success('Registro guardado');
    });
  }

  handleTruckCreate(record) {
    axios.post(`${Configuration.apiServer}/api/v1/trucks`, {truck: record}, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.getTrucks();
      this.setState({modalTruckVisible: false});
      message.success('Registro guardado');
    });
  }

  handleCarrierCreate(record) {
    axios.post(`${Configuration.apiServer}/api/v1/carriers`, {carrier: record}, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.getCarriers();
      this.setState({modalCarrierVisible: false});
      message.success('Registro guardado');
    });
  }

  handleVisitTicketKind(value) {
    const kind = value.split('-');
    this.setProp('visit_ticket_kind_id', kind[0]);
    this.setProp('visit_ticket_kind_name', kind[1]);
  }

  handleTruckKind(value) {
    const kind = value.split('-');
    this.setProp('truck_kind_id', kind[0]);
    this.setProp('truck_kind_name', kind[1]);
  }

  handleTruck(value) {
    const truck = value.split('-');
    this.setProp('truck_id', truck[0]);
    this.setProp('truck_name', truck[1]);
  }

  handleCarrier(value) {
    const carrier = value.split('-');
    this.setProp('carrier_id', carrier[0]);
    this.setProp('carrier_name', carrier[1]);
  }
  
  handleDriver(value) {
    const driver = value.split('-');
    this.setProp('driver_id', driver[0]);
    this.setProp('driver_name', driver[1]);
  }

  handleWarehouse(value) {
    const warehouse = value.split('-');
    this.setProp('warehouse_id', warehouse[0]);
    this.setProp('warehouse_name', warehouse[1]);
  }

  handleWeight(event) {
    this.setProp('weight_limit', event.target.value);
  }

  handleDueDate(value) {
    this.setProp('due_date', value.format('YYYY-MM-DD'));
  }

  handleTime(value) {
    this.setProp('time', value.format('HH:mm:ss'));
  }

  handleDetails(event) {
    this.setProp('details', event.target.value);
  }

  setProp(prop, value) {
    const record = this.state.visitCarrier;
    let validation = this.state.stepValidation;
    record[prop] = value;
    
    // Update validation
    if(String(value).length > 0) {
      validation[`step${this.state.step}`][prop] = true;
    } else {
      validation[`step${this.state.step}`][prop] = false;
    }

    this.setState({visitCarrier: record, stepValidation: validation});
  }

  showStep(step) {
    if(step === this.state.step) {
      return 'block';
    } else {
      return 'none';
    }
  }

  render() {
    // Options for visit ticket kinds select
    const visitTicketKindOptions = this.state.visitTicketKinds.map(kind => {
      return (
        <Option value={`${kind.id}-${kind.name}`} className="text-capitalize" key={`visitTicketKind:${kind.id}`}>{kind.name}</Option>
      );
    });
    // Options for truck kinds select
    const truckKindOptions = this.state.truckKinds.map(kind => {
      return (
        <Option value={`${kind.id}-${kind.name}`} className="text-capitalize" key={`truckKind:${kind.id}`}>{kind.name}</Option>
      );
    });
    // Options for trucks select
    const truckOptions = this.state.trucks.map(truck => {
      return (
        <Option value={`${truck.id}-${truck.references}`} className="text-capitalize" key={`truck:${truck.id}`}>{truck.plates} / {truck.reference}</Option>
      );
    });
    // Options for carriers select
    const carrierOptions = this.state.carriers.map(carrier => {
      return (
        <Option value={`${carrier.id}-${carrier.name}`} className="text-capitalize" key={`carrier:${carrier.id}`}>{carrier.name}</Option>
      );
    });
    // Options for drivers select
    const driverOptions = this.state.drivers.map(driver => {
      return (
        <Option value={`${driver.id}-${driver.name}`} className="text-capitalize" key={`driver:${driver.id}`}>{driver.name}</Option>
      );
    });
    // Options for warehouses select
    const warehouseOptions = this.state.warehouses.map(warehouse => {
      return (
        <Option value={`${warehouse.id}-${warehouse.name}`} className="text-capitalize" key={`driver:${warehouse.id}`}>{warehouse.name}</Option>
      );
    })

    // Render component
    return (
      <div>
        <Modal
          title="Visita de empleado"
          visible={this.props.visible}
          onCancel={() => { this.props.handleClose('carrierVisible') }}
          width={900}
          footer={null}
          destroyOnClose={true}
        >
          <div className="row" style={{ padding: '0px 30px' }}>
            <Steps size="small" current={this.state.step}>
              <Step title="Asunto" />
              <Step title="Camión" />
              <Step title="Transportista" />
              <Step title="Almacén" />
              <Step title="Fecha" />
              <Step title="Detalles" />
            </Steps>
          </div>

          <br/> <br/>

          <div className="row" style={{ padding: '0px 30px' }}>
            <div style={{ width: '100%', display: this.showStep(0) }}>
              <div className="form-group">
                <label>Tipo de visita</label>
                <Select
                  showSearch
                  style={{ width: '100%' }}
                  placeholder="Elige un tipo de visita"
                  optionFilterProp="children"
                  onChange={this.handleVisitTicketKind}
                  filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                >
                  {visitTicketKindOptions}
                </Select>
              </div>
            </div>

            <div style={{ width: '100%', display: this.showStep(1) }}>
              <div className="form-group">
                <label>Tipo de camión</label>
                <Select
                  showSearch
                  style={{ width: '100%' }}
                  placeholder="Elige un tipo de camión"
                  optionFilterProp="children"
                  onChange={this.handleTruckKind}
                  filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                >
                  {truckKindOptions}
                </Select>
              </div>

              <div className="form-group">
                <label>Camión</label>
                <div className="d-flex justify-content-between align-items-center">
                  <Select
                    showSearch
                    style={{ width: '90%' }}
                    placeholder="Elige un camión"
                    optionFilterProp="children"
                    onChange={this.handleTruck}
                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                  >
                    {truckOptions}
                  </Select>
                  <Button icon="plus" type="primary" shape="circle" onClick={this.handleOpenTruckModal} />
                </div>
              </div>
            </div>

            <div style={{ width: '100%', display: this.showStep(2) }}>
              <div className="form-group">
                <label>Transportista</label>
                <div className="d-flex justify-content-between align-items-center">
                  <Select
                    showSearch
                    style={{ width: '90%' }}
                    placeholder="Elige una persona"
                    optionFilterProp="children"
                    onChange={this.handleCarrier}
                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                  >
                    {carrierOptions}
                  </Select>
                  <Button icon="plus" type="primary" shape="circle" onClick={this.handleOpenCarrierModal} />
                </div>
              </div>

              <div className="form-group">
                <label>Conductor</label>
                <div className="d-flex justify-content-between align-items-center">
                  <Select
                    showSearch
                    style={{ width: '90%' }}
                    placeholder="Elige un conductor"
                    optionFilterProp="children"
                    onChange={this.handleDriver}
                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                  >
                    {driverOptions}
                  </Select>
                  <Button icon="plus" type="primary" shape="circle" onClick={this.handleOpenDriverModal} />
                </div>
              </div>
            </div>

            <div style={{ width: '100%', display: this.showStep(3) }}>
              <div className="form-group">
                <label>Almacén</label>
                <Select
                  showSearch
                  style={{ width: '100%' }}
                  placeholder="Elige un almacén"
                  optionFilterProp="children"
                  onChange={this.handleWarehouse}
                  filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                >
                  {warehouseOptions}
                </Select>
              </div>

              <div className="form-group">
                <label>Peso límite</label>
                <input type="number" className="form-control" defaultValue={30000} onChange={this.handleWeight} />
              </div>
            </div>
            
            <div style={{ width: '100%', display: this.showStep(4) }}>
              <div className="form-group">
                <label>¿Qué día es la visita?</label>
                <br />
                <DatePicker onChange={this.handleDueDate} style={{ width: '100%' }} />
              </div>
              <div className="form-group">
                <label>¿A qué hora llega la visita?</label>
                <br />
                <TimePicker onChange={this.handleTime} style={{ width: '100%' }}  />
              </div>
            </div>

            <div style={{ width: '100%', display: this.showStep(5) }}>
              <div className="form-group">
                <label>Detalles (Opcional)</label>
                <input type="text" className="form-control" placeholder="Escribe algunos detalles sobre la visita" onChange={this.handleDetails} />
              </div>
            </div>
          </div>

          <br/><hr/>

          <div className="form-group text-center">
            <Button type="dashed" style={{ marginRight: '10px' }} onClick={this.handleBack}>Atras</Button>
            <Button type="primary" onClick={this.handleNext}>Siguiente</Button>
          </div>
        </Modal>

        <DriverModal visible={this.state.modalDriverVisible} title={"Nuevo conductor"} current={this.schemaDriver} handleClose={this.handleCloseDriverModal} handleSave={this.handleDriverCreate} />
        <TruckModal visible={this.state.modalTruckVisible} title={"Nuevo camión"} current={this.schemaTruck} handleClose={this.handleCloseTruckModal} handleSave={this.handleTruckCreate} />
        <CarrierModal visible={this.state.modalCarrierVisible} title={"Nuevo transportista"} current={this.schemaCarrier} handleClose={this.handleCloseCarrierModal} handleSave={this.handleCarrierCreate} />
      </div>
    );
  }
}

export default VisitCarrierModal;



// WEBPACK FOOTER //
// ./src/components/modals/VisitCarrierModal.js